import axiosInstance from './axiosInstance';

export interface ICaregiverCareHomeSummary {
  id: string;
  organisation_id: string;
  name: string;
  type: string;
}

export interface ICaregiver {
  id: string;
  name: string;
  pin: string;
  is_active: boolean;
  carehome: ICaregiverCareHomeSummary;
}

export interface ICaregiverListResponse {
  items: ICaregiver[];
  limit: number;
  offset: number;
  total: number;
}

export interface ICreateCaregiverPayload {
  name: string;
  pin: string;
  is_active: boolean;
  carehome_id: string;
}

export interface IUpdateCaregiverPayload {
  name?: string;
  pin?: string;
  is_active?: boolean;
  carehome_id?: string;
}

export interface IUpdateCaregiverStatusPayload {
  is_active: boolean;
}

class CaregiverService {
  private static instance: CaregiverService;

  private constructor() {}

  public static getInstance(): CaregiverService {
    if (!CaregiverService.instance) {
      CaregiverService.instance = new CaregiverService();
    }
    return CaregiverService.instance;
  }

  public async getCaregivers(
    page = 1,
    per_page = 50,
    query?: string,
    ignore_case?: boolean,
    orderBy?: string,
    sortOrder: 'asc' | 'desc' | null = 'desc',
    tags?: string,
    carehome_id?: string,
    is_active?: boolean,
  ): Promise<ICaregiverListResponse> {
    const response = await axiosInstance.get<ICaregiverListResponse>('/caregivers', {
      params: {
        page,
        per_page,
        query,
        ignore_case,
        orderBy,
        sortOrder,
        tags,
        carehome_id,
        is_active,
      },
    });

    return response.data;
  }

  public async createCaregiver(
    payload: ICreateCaregiverPayload,
  ): Promise<ICaregiver> {
    const response = await axiosInstance.post<ICaregiver>('/caregivers', payload);
    return response.data;
  }

  public async updateCaregiver(
    caregiverId: string,
    payload: IUpdateCaregiverPayload,
  ): Promise<ICaregiver> {
    const response = await axiosInstance.put<ICaregiver>(`/caregivers/${caregiverId}`, payload);
    return response.data;
  }

  /**
   * Update caregiver active/archived status.
   * PATCH /caregivers/{caregiver_id}/status
   */
  public async updateCaregiverStatus(
    caregiverId: string,
    payload: IUpdateCaregiverStatusPayload,
  ): Promise<ICaregiver> {
    const response = await axiosInstance.patch<ICaregiver>(`/caregivers/${caregiverId}/status`, payload);
    return response.data;
  }
}

export default CaregiverService.getInstance();


